import _ from 'lodash';

/** calcTVA library by Tolga MALKOC | ghostlexly@gmail.com */
export default {
	/**
	 * Basic TTC from HT conversion
	 *
	 * @param ht
	 * @param taxRate
	 * @returns {string}
	 */
	calcTTCfromHT: function (ht, taxRate) {
		return (parseFloat(ht) + (ht * taxRate) / 100).toFixed(2);
	},

	/**
	 * Basic HT from TTC conversion
	 *
	 * @param ttc
	 * @param taxRate
	 * @returns {string}
	 */
	calcHTfromTTC: function (ttc, taxRate) {
		return (ttc / (1 + taxRate / 100)).toFixed(2);
	},
};
